import React from 'react';

import { ContestReattempt } from 'features/classCreation';
import Field from 'components/Field';
import styles from './GroupsContestSummary.module.scss';

function GroupsContestSummary({ interviewbitTests }) {
  return (
    <Field label="Group Contest Summary">
      <div className={styles.root}>
        {interviewbitTests.map((interviewbitTest) => (
          <ContestReattempt
            interviewbitTest={interviewbitTest}
            key={interviewbitTest.test_id}
            isClassTemplate
          />
        ))}
      </div>
    </Field>
  );
}

export default GroupsContestSummary;
